export default {
    wizardType: "PAYMO",

    getConnectionParams: (type, model) => ({
        APIKey: model.get("apiKey"),
    }),
};

